/**
 * Material Design easing curves
 *
 * See [here](https://material.io/archive/guidelines/motion/duration-easing.html#duration-easing-speed)
 * to learn the context in which each easing should be used.
 */
const Easing = {
  // This is the most common easing curve.
  EASE_IN_OUT: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  EASE_OUT: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  EASE_IN: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  SHARP: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

/**
 * Material Design animation durations
 *
 * See [here](https://material.io/design/motion/speed.html#duration)
 * to learn when to use what timing.
 */
const Duration = {
  SHORTEST: 150,
  SHORTER: 200,
  SHORT: 250,
  // The most basic, recommended timing
  STANDARD: 300,
  // This is to be used in complex animations
  COMPLEX: 375,
  // Recommended when something is entering screen
  ENTERING_SCREEN: 225,
  // Recommended when something is leaving screen
  LEAVING_SCREEN: 195
};
const DEFAULT_TIMEOUT = {
  enter: Duration.ENTERING_SCREEN,
  exit: Duration.LEAVING_SCREEN
};
export { DEFAULT_TIMEOUT, Duration, Easing };